import { render, staticRenderFns } from "./store-sel-page.vue?vue&type=template&id=508953b7&scoped=true"
import script from "./store-sel-page.vue?vue&type=script&lang=js"
export * from "./store-sel-page.vue?vue&type=script&lang=js"
import style0 from "./store-sel-page.vue?vue&type=style&index=0&id=508953b7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508953b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508953b7')) {
      api.createRecord('508953b7', component.options)
    } else {
      api.reload('508953b7', component.options)
    }
    module.hot.accept("./store-sel-page.vue?vue&type=template&id=508953b7&scoped=true", function () {
      api.rerender('508953b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/store-sel-page.vue"
export default component.exports